module.exports = "/assets/2alIgxCpR_.png";